import React, {useState, useEffect, Fragment} from 'react';
import 'fontsource-roboto';
import {makeStyles} from '@material-ui/core/styles';
import useIsMountedRef from './../Components/useIsMountedRef';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';

import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  errorMain: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.main
  },
  errorLight: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.light
  },
  errorDark: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.dark
  },
  warningMain: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.main
  },
  warningLight: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.light
  },
  warningDark: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.dark
  },
  infoMain: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.main
  },
  infoLight: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.light
  },
  infoDark: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.dark
  },
  successMain: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.main
  },
  successLight: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.light
  },
  successDark: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.dark
  },
  divider: {
    margin: theme.spacing(.5, 0)
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(0.5)
  },
  cardHeader: {
    padding: theme.spacing(1, 2, 1)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function AddReception(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState({
    id: '',
    idCompanySL: false,
    isPregnant: false,
    surname: '',
    name: '',
    cnp: '',
    phone: '',
    ticketSerial: '',
    ticketNumber: '',
    ticketDate: (new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60 * 1000))).toISOString().split('T')[0],
    description: '',
    servicePacks: [],
    services: []
  });
  const [resellerCnasLimit, setResellerCnasLimit] = useState(null);
  const [servicePacks, setServicePacks] = useState([]);
  const [services, setServices] = useState([]);
  const [servicesPaidByCnas, setServicesPaidByCnas] = useState([]);
  const [idResellerReception, setIdResellerReception] = useState(null);
  const [deleteIdReception, setDeleteIdReception] = useState(null);

  useEffect(() => {
    if (resellerCnasLimit !== null && !Boolean(resellerCnasLimit)) {
      setData({...data, idCompanySL: null, isPregnant: null});
    }
    setIsLoaded(true);
  }, [resellerCnasLimit]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setIsLoaded(false);
    if (props.match.params.idReception) {
      ajax('resellerReception', {
        idReception: props.match.params.idReception
      })
        .then(response => {
          if (!isMountedRef.current) return;

          if (response.ok) {
            setData(response.data.reception);
            setServicePacks(response.data.servicePacks);
            setServices(response.data.services);
            setServicesPaidByCnas(response.data.servicesPaidByCnas);
            setResellerCnasLimit(parseInt(response.data.resellerCnasLimit));
          }
        });
    } else {
      ajax('resellerServices', props.match.params.cnp ? {cnp: props.match.params.cnp} : {})
        .then(response => {
          if (!isMountedRef.current) return;

          if (response.ok) {
            setServicePacks(response.data.servicePacks);
            setServices(response.data.services);
            setServicesPaidByCnas(response.data.servicesPaidByCnas);
            setResellerCnasLimit(parseInt(response.data.resellerCnasLimit));
            if (props.match.params.cnp)
              setData({...data, ...response.data.patient});
          }
        });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDataChange = e => {
    setData({...data, [e.target.name]: e.target.value});
  };

  const getTotalPriceSL = () => data.servicePacks.reduce((a, b) => a + (parseInt(b.price) === 0 ? 0 : +b.priceSL), 0) + data.services.reduce((a, b) => a + (parseInt(b.price) === 0 ? 0 : +b.priceSL), 0);
  const getTotalPrice = () => data.servicePacks.reduce((a, b) => a + (parseInt(b.price) === 0 ? 0 : +b.price), 0) + data.services.reduce((a, b) => a + (parseInt(b.price) === 0 ? 0 : +b.price), 0);

  const handleServicePackAdd = (e, value, reason) => {
    let dataServicePacks = data.servicePacks;
    let dataServices = data.services;
    switch (reason) {
      case 'select-option':
        dataServicePacks.push(value);
        dataServices = dataServices.filter(service => !~dataServicePacks.map(servicePack => servicePack.idServicesSL).join(',').split(',').indexOf(service.idServiceSL));
        setData({...data, servicePacks: dataServicePacks, services: dataServices});
        break;
      default:
        break;
    };
  };

  const handleServiceAdd = (e, value, reason) => {
    let dataServices = data.services;
    switch (reason) {
      case 'select-option':
        dataServices.push(value);
        setData({...data, services: dataServices});
        break;
      default:
        break;
    };
  };

  const getAvailableServicePacks = () => {
    return servicePacks.filter(servicePack => !data.servicePacks.includes(servicePack));
  };
  const getAvailableServices = () => {
    return services.filter(service => !data.services.includes(service) && !~data.servicePacks.map(servicePack => servicePack.idServicesSL).join(',').split(',').indexOf(service.idServiceSL));
  };
  const getAvailableServicesPaidByCnas = () => {
    return servicesPaidByCnas.filter(service => !data.services.includes(service) && (data.isPregnant === '1' || (data.isPregnant === '0' && service.mustBePregnant === '0')));
  };

  const handleServicePackDelete = (idServicePackSL) => {
    let dataServicePacks = data.servicePacks.filter(servicePack => servicePack.idServicePackSL !== idServicePackSL);
    setData({...data, servicePacks: dataServicePacks});
  };

  const handleServiceDelete = (idServiceSL) => {
    let dataServices = data.services.filter(service => service.idServiceSL !== idServiceSL);
    setData({...data, services: dataServices});
  };

  const handleSubmitData = async () => {
    setIsLoaded(false);
    ajax('resellerReceptionSave', {
      ...data,
      description: data.description + '\n\nConsumabile:\n' + getVacutainers().join('\n')
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setIdResellerReception(response.data);

        setIsLoaded(true);
      });
  };

  const getVacutainers = () => {
    return [...new Set(
      data.servicePacks.map(servicePack => servicePack.consumables)
      .concat(data.services.map(service => service.consumables))
      .join('|')
      .split('|')
      .filter(item => Boolean(item))
      .sort()
    )]
  };

  const markReceptionAsDeleted = () => {
    setIsLoaded(false);
    ajax('resellerMarkReceptionAsDeleted', {
      id: deleteIdReception
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          props.history.replace('/Receptions');
      });
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Adaugare recoltare</Typography>
      <Typography variant='subtitle2'>Adaugare recoltare pentru Sunmed Tulcea</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && Boolean(resellerCnasLimit) && data.idCompanySL === false &&
        <Box>
          <Typography variant='subtitle1'>Selectati metoda de plata catre laboratorul de analize</Typography>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button variant='outlined' color='primary' fullWidth style={{padding: '32px 4px'}}
                onClick={() => setData({...data, idCompanySL: null, isPregnant: null})}
              >
                Analize contra cost
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button variant='outlined' color='primary' fullWidth style={{padding: '32px 4px'}}
                onClick={() => setData({...data, idCompanySL: '8'})}
              >
                Analize decontate de CAS
              </Button>
            </Grid>
          </Grid>
          <Typography variant='subtitle2' color='secondary'>Luna aceasta mai puteti adauga inca {resellerCnasLimit} trimiteri decontate de CAS </Typography>
        </Box>
      }

      {isLoaded && Boolean(resellerCnasLimit) && Boolean(data.idCompanySL) && data.isPregnant === false &&
        <Box>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant='subtitle1'>Pacienta este gravida?</Typography>
            </Grid>
            <Grid item xs={6}>
              <Button variant='outlined' color='primary' fullWidth style={{padding: '32px 4px'}}
                onClick={() => setData({...data, isPregnant: '1'})}
              >
                DA
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button variant='outlined' color='primary' fullWidth style={{padding: '32px 4px'}}
                onClick={() => setData({...data, isPregnant: '0'})}
              >
                NU
              </Button>
            </Grid>
          </Grid>
        </Box>
      }

      {isLoaded && (!Boolean(resellerCnasLimit) || (Boolean(resellerCnasLimit) && data.idCompanySL !== false && data.isPregnant !== false)) &&
        <Fragment>
          <Card className={classes.card}>
            <CardContent>
              {!Boolean(idResellerReception)
                ? <Typography component='div' variant='subtitle2' color='error'>ID-ul recoltarii se va afisa dupa salvare!</Typography>
                : <Fragment>
                    <Typography component='div' variant='h6' color='secondary'>
                      Recoltare salvata! ID:&nbsp;
                      <Typography component='div' variant='h6' color='primary' display='inline'>{idResellerReception}</Typography>
                    </Typography>
                    <Typography component='div' color='textPrimary'>Marcati {getVacutainers().length === 1 ? 'vacutainerul' : 'vacutainerele'} cu acest numar (ID)</Typography>
                    <Button variant='contained' color='primary' style={{float: 'right'}}
                      onClick={() => window.open(`${props.url.download}?op=resellerComandaAnalize&idResselerReceptions=${idResellerReception}&SID=${props.user.sessid}&variant=live`)}
                    >
                      Descarca comanda de analize
                    </Button>
                  </Fragment>
              }
            </CardContent>
          </Card>

          <Card className={classes.card}>
            <CardContent>
              <Typography variant='h6'>Necesar vacutainere</Typography>
              <Divider />
              {Boolean(getVacutainers().length)
                ? <List dense>
                    {getVacutainers().map(consumable =>
                      <ListItem key={consumable} disableGutters>
                        <ListItemText
                          primary={consumable}
                        />
                      </ListItem>
                    )}
                  </List>
                : <Typography color='textSecondary'>Nu sunt necesare vacutainere</Typography>
              }
            </CardContent>
          </Card>

          {data.idCompanySL === null &&
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4}>
                <Card className={classes.card}>
                  <CardContent className={`${classes.cardContent} ${classes.infoMain}`}>
                    <Typography component='div' align='center'>Venituri</Typography>
                    <Typography variant='subtitle2' align='center'>{getTotalPrice().toFixed(2)} RON</Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} sm={4}>
                <Card className={classes.card}>
                  <CardContent className={`${classes.cardContent} ${classes.errorMain}`}>
                    <Typography component='div' align='center'>Cheltuieli</Typography>
                    <Typography variant='subtitle2' align='center'>{getTotalPriceSL().toFixed(2)} RON</Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} sm={4}>
                <Card className={classes.card}>
                  <CardContent className={`${classes.cardContent} ${classes.successLight}`}>
                    <Typography component='div' align='center'>Profit</Typography>
                    <Typography variant='subtitle2' align='center'>{(getTotalPrice() - getTotalPriceSL()).toFixed(2)} RON</Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          }

          <Card className={classes.card}>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant='h6'>Detalii pacient</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField margin='none' required inputProps={{maxLength: 64}}
                    disabled={Boolean(idResellerReception)}
                    error={data.surname.length < 3}
                    helperText={data.surname.length < 3 ? 'Minim 3 caractere' : ' '}
                    label='Nume'
                    placeholder='Nume'
                    name='surname'
                    value={data.surname}
                    onChange={handleDataChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField margin='none' required inputProps={{maxLength: 64}}
                    disabled={Boolean(idResellerReception)}
                    error={data.name.length < 3}
                    helperText={data.name.length < 3 ? 'Minim 3 caractere' : ' '}
                    label='Prenume'
                    placeholder='Prenume'
                    name='name'
                    value={data.name}
                    onChange={handleDataChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField margin='none' required inputProps={{maxLength: 13}}
                    disabled={Boolean(idResellerReception)}
                    error={!RegExp(/^\d{13}$/, 'gmi').test(data.cnp)}
                    helperText={!RegExp(/^\d{13}$/, 'gmi').test(data.cnp) ? 'Exact 13 cifre' : ' '}
                    label='CNP'
                    placeholder='CNP'
                    name='cnp'
                    value={data.cnp}
                    onChange={handleDataChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField margin='none' inputProps={{maxLength: 10}}
                    disabled={Boolean(idResellerReception)}
                    // error={!RegExp(/^07\d{8}$/, 'gmi').test(data.phone)}
                    helperText={!RegExp(/^07\d{8}$/, 'gmi').test(data.phone) ? 'Fix 10 cifre (07xxx)' : ' '}
                    label='Telefon'
                    placeholder='Telefon'
                    name='phone'
                    value={data.phone}
                    onChange={handleDataChange}
                  />
                </Grid>
                {data.idCompanySL !== null &&
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField margin='none' inputProps={{maxLength: 16}}
                      disabled={Boolean(idResellerReception)}
                      error={!RegExp(/^[A-Za-z]{5,}$/, 'gmi').test(data.ticketSerial)}
                      helperText={!RegExp(/^[A-Za-z]{5,}$/, 'gmi').test(data.ticketSerial) ? 'Minim 5 litere' : ' '}
                      label='Serie bilet de trimitere'
                      placeholder='Serie bilet de trimitere'
                      name='ticketSerial'
                      value={data.ticketSerial}
                      onChange={handleDataChange}
                    />
                  </Grid>
                }
                {data.idCompanySL !== null &&
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField margin='none' inputProps={{maxLength: 16}}
                      disabled={Boolean(idResellerReception)}
                      error={!RegExp(/^\d{5,}$/, 'gmi').test(data.ticketNumber)}
                      helperText={!RegExp(/^\d{5,}$/, 'gmi').test(data.ticketNumber) ? 'Minim 5 cifre' : ' '}
                      label='Numar bilet de trimitere'
                      placeholder='Numar bilet de trimitere'
                      name='ticketNumber'
                      value={data.ticketNumber}
                      onChange={handleDataChange}
                    />
                  </Grid>
                }
                {data.idCompanySL !== null &&
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField margin='none' type='date' inputProps={{max: (new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60 * 1000))).toISOString().split('T')[0]}}
                      disabled={Boolean(idResellerReception)}
                      error={!RegExp(/^\d\d\d\d-\d\d-\d\d$/, 'gmi').test(data.ticketDate)}
                      helperText={!RegExp(/^\d\d\d\d-\d\d-\d\d$/, 'gmi').test(data.ticketDate) ? 'Selectati o data din calendar' : ' '}
                      label='Data bilet de trimitere'
                      placeholder='Data bilet de trimitere'
                      name='ticketDate'
                      value={data.ticketDate}
                      onChange={handleDataChange}
                    />
                  </Grid>
                }
                <Grid item xs={12}>
                  <TextField margin='none' multiline rows={3} rowsMax={5}
                    disabled={Boolean(idResellerReception)}
                    label='Observatii'
                    placeholder='Observatii'
                    name='description'
                    value={data.description}
                    onChange={handleDataChange}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card className={classes.card}>
            <CardContent>
              <Typography variant='h6'>Lista servicii</Typography>
              {data.idCompanySL !== null &&
                <Typography variant='subtitle2' color='primary'>Sunt afisate doar serviciile decontate prin CAS pentru tipul de persoana ales</Typography>
              }
              {!Boolean(data.servicePacks.length + data.services.length) &&
                <Warning>Selectati cel putin un serviciu!</Warning>
              }

              <Grid container spacing={1}>
                {data.idCompanySL === null &&
                  <Grid item xs={12} md={6}>
                    <Autocomplete clearOnBlur={true} blurOnSelect className={classes.infoLight}
                      key={`services_${data.services.length}`}
                      disabled={Boolean(idResellerReception)}
                      options={getAvailableServices()}
                      getOptionLabel={service => service.service}
                      groupBy={service => service.category}
                      renderInput={params => <TextField {...params} label='Selectati de aici analiza dorita' />}
                      onChange={handleServiceAdd}
                    />
                    <List>
                      {data.services.map(service =>
                        <ListItem key={service.idServiceSL} dense disableGutters>
                          <ListItemText
                            primary={<Typography component='div' variant='subtitle2' color='textPrimary' noWrap title={service.service}>{service.service}</Typography>}
                            secondary={
                              <Typography component='div' color='textSecondary'>
                                {`${service.category} - rezultate: ${service.worktime === '0' ? 'in aceeasi zi' : service.worktime === '1' ? 'dupa o zi' : `dupa ${service.worktime} zile`}`}
                                <Typography variant='subtitle2' color='primary' display='inline' style={{float: 'right', paddingRight: '16px'}}>{service.price} RON</Typography>
                              </Typography>
                            }
                          />
                          {!Boolean(idResellerReception) &&
                            <ListItemSecondaryAction>
                              <IconButton edge='end'
                                onClick={() => handleServiceDelete(service.idServiceSL)}
                              >
                                <DeleteIcon color='secondary' />
                              </IconButton>
                            </ListItemSecondaryAction>
                          }
                        </ListItem>
                      )}
                    </List>
                  </Grid>
                }

                {data.idCompanySL === null &&
                  <Grid item xs={12} md={6}>
                    <Autocomplete clearOnBlur={true} blurOnSelect className={classes.infoLight}
                      key={`servicePacks_${data.servicePacks.length}`}
                      disabled={Boolean(idResellerReception)}
                      options={getAvailableServicePacks()}
                      getOptionLabel={servicePack => servicePack.servicePack}
                      renderOption={option => <Typography variant='body1' title={option.services}>{option.servicePack}</Typography>}
                      renderInput={params => <TextField {...params} label='Selectati de aici pachetul dorit' />}
                      onChange={handleServicePackAdd}
                    />
                    <List>
                      {data.servicePacks.map(servicePack =>
                        <ListItem key={servicePack.idServicePackSL} dense disableGutters>
                          <ListItemText
                            primary={<Typography component='div' variant='subtitle2' color='textPrimary' noWrap title={servicePack.servicePack}>{servicePack.servicePack}</Typography>}
                            secondary={
                              <Typography component='div' color='textSecondary'>
                                {`Rezultate: ${servicePack.worktime === '0' ? 'in aceeasi zi' : servicePack.worktime === '1' ? 'dupa o zi' : `dupa ${servicePack.worktime} zile`}`}
                                <Typography variant='subtitle2' color='primary' display='inline' style={{float: 'right', paddingRight: '16px'}}>{servicePack.price} RON</Typography>
                              </Typography>
                            }
                          />
                          {!Boolean(idResellerReception) &&
                            <ListItemSecondaryAction>
                              <IconButton edge='end'
                                onClick={() => handleServicePackDelete(servicePack.idServicePackSL)}
                              >
                                <DeleteIcon color='secondary' />
                              </IconButton>
                            </ListItemSecondaryAction>
                          }
                        </ListItem>
                      )}
                    </List>
                    <Typography variant='caption' color='secondary'>* Pentru a inspecta serviciile din care este compus un pachet de analize, pozitionati mouse-ul exact pe numele pachetul dorit (chiar deasupra denumirii pachetului de analize, nu mai sus, mai jos sau in dreapta acestuia)</Typography>
                  </Grid>
                }

                {data.idCompanySL !== null &&
                  <Grid item xs={12} md={6}>
                    <Autocomplete clearOnBlur={true} blurOnSelect className={classes.infoLight}
                      key={`services_${data.services.length}`}
                      disabled={Boolean(idResellerReception)}
                      options={getAvailableServicesPaidByCnas()}
                      getOptionLabel={service => service.service}
                      groupBy={service => service.category}
                      renderInput={params => <TextField {...params} label='Selectati de aici analiza dorita' />}
                      onChange={handleServiceAdd}
                    />
                    <List>
                      {data.services.map(service =>
                        <ListItem key={service.idServiceSL} dense disableGutters>
                          <ListItemText
                            primary={<Typography component='div' variant='subtitle2' color='textPrimary' noWrap title={service.service}>{service.service}</Typography>}
                            secondary={
                              <Typography component='div' color='textSecondary'>
                                {`${service.category} - rezultate: ${service.worktime === '0' ? 'in aceeasi zi' : service.worktime === '1' ? 'dupa o zi' : `dupa ${service.worktime} zile`}`}
                              </Typography>
                            }
                          />
                          {!Boolean(idResellerReception) &&
                            <ListItemSecondaryAction>
                              <IconButton edge='end'
                                onClick={() => handleServiceDelete(service.idServiceSL)}
                              >
                                <DeleteIcon color='secondary' />
                              </IconButton>
                            </ListItemSecondaryAction>
                          }
                        </ListItem>
                      )}
                    </List>
                  </Grid>
                }
              </Grid>
            </CardContent>
          </Card>
        </Fragment>
      }

      {isLoaded && (!Boolean(resellerCnasLimit) || (Boolean(resellerCnasLimit) && data.idCompanySL !== false && data.isPregnant !== false)) && !Boolean(idResellerReception) && Boolean(props.user.idPartner) &&
        <Fab className={classes.fab}
          disabled={false
            || data.surname.length < 3
            || data.name.length < 3
            || !RegExp(/^\d{13}$/, 'gmi').test(data.cnp)
            // || !RegExp(/^07\d{8}$/, 'gmi').test(data.phone)
            || (data.idCompanySL !== null && !RegExp(/^[A-Za-z]{5,}$/, 'gmi').test(data.ticketSerial))
            || (data.idCompanySL !== null && !RegExp(/^\d{5,}$/, 'gmi').test(data.ticketNumber))
            || (data.idCompanySL !== null && !RegExp(/^\d\d\d\d-\d\d-\d\d$/, 'gmi').test(data.ticketDate))
            || !Boolean(data.servicePacks.length + data.services.length)
          }
          onClick={handleSubmitData}
        >
          <CheckIcon />
        </Fab>
      }

      {isLoaded && (!Boolean(resellerCnasLimit) || (Boolean(resellerCnasLimit) && data.idCompanySL !== false && data.isPregnant !== false)) && Boolean(data.id) && Boolean(props.user.idPartner) && !Boolean(data.servicePacks.length + data.services.length) &&
        <Fab className={classes.fab}
          color='secondary'
          onClick={() => setDeleteIdReception(data.id)}
        >
          <DeleteIcon />
        </Fab>
      }

      <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
        open={Boolean(parseInt(deleteIdReception))}
        TransitionComponent={Transition}
        onClose={() => setDeleteIdReception(null)}
      >
        <DialogTitle>Marcati aceste probe ca sterse?</DialogTitle>
        <DialogContent>
          <DialogContentText><Typography component='span' display='block' align='justify'>Apasati pe DA doar daca sunteti sigur ca doriti sa stergeti aceasta recoltare. Dupa stergere nu veti mai avea acces la aceasta recoltare.</Typography></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={!isLoaded} onClick={() => setDeleteIdReception(null)}>
            NU
          </Button>
          <Button disabled={!isLoaded} onClick={markReceptionAsDeleted} color='primary'>
            DA
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}